import ApiService from "./api.service";

const UsersService = {
  signUp(payload) {
    console.log("here payload");
    return ApiService.post("/user/register", payload);
  },
  signIn(payload) {
    return ApiService.post("/api/signin", payload);
  },
  changePassword(payload) {
    return ApiService.post("/user/change-password", payload);
  },
  trackEvent(payload) {
    return ApiService.post("/user/track", payload);
  },
  verifyEmail(payload) {
    return ApiService.post("/api/verify-email", payload);
  }
}

export default UsersService;
